export const basePath = 'api'

export interface Post {
  id: number | null;
  userId: number;
  subject: string;
  location: string;
  description: string;
  isApproved: boolean;
  isDeleted: boolean;
  isOpen: boolean;
  isRejected: boolean;
  rejectReason: string;
  date: string;
  time: string;
  type: {
    typeId: number;
    const: string;
    name: string;
  };
  group: {
    id: number;
    name: string;
    country: {
      id: number;
      name: string;
    };
    latitude: number;
    longitude: number;
    timezone: string;
    uniqueName?: string;
  };
  images: [];
  tags: [];
  shared: [];
  static: string | null;
}

export interface SearchResult {
  "@timestamp": string;
  "@version": string;
  group_id: number;
  group_name: string;
  group_uniquename: string;
  has_image: number;
  index_id: string;
  is_approved: number;
  is_deleted: number;
  is_open: number;
  is_rejected: number;
  post_date: string;
  post_datetime: string;
  post_description: string;
  post_id: number;
  post_location: string;
  post_subject: string;
  post_type: number;
  post_type_name: string;
  type: string;
  user_id: number;
  username: string;
}

export interface NewPost {
  userId: number;
  subject: string;
  location: string;
  description: string;
  type: number;
  lendDuration: string | null;
  town: number;
  tags: [];
  images: [];
  user: {
    user_id: number;
    username: string;
  };
}

export interface ModuleState {
  post?: Post;
  posts: Post[];
  postsByTownByUserByStatus: {
    active?: Post[];
    inactive?: Post[];
    pending?: Post[];
  };
  postsByTownByUserPending: Post[];
  postsByTownByUserActive: Post[];
  postsByTownByUserInactive: Post[];
  postsByTownPending: Post[]; // Support multiple towns
}

export type PostStatus = 'active'|'inactive'|'pending'
